import React, { FC, MouseEvent, useState } from 'react';
import { styled } from 'linaria/react';
import { useFormikContext } from 'formik';
import { PaymentFormValues } from '@entities/payment';
import { useCyberStore } from '@entities/tsp';
import { getSteamAccountFinalAmount } from '@entities/price';
import { PROMOCODES, PROMOCODES_FROM_2K } from '@entities/promocode';
import { useBreakpoint } from '@shared/lib/react';
import { MESSAGE_ERROR_PROMOCODE } from '@shared/config';
import { Button } from '@shared/ui/molecules';
import { Amount } from '@root/api/ump-ewallet';
interface ActivatePromocodeButtonProps {
  getCommissions: (amount: Required<Pick<Amount, 'base' | 'fee' | 'total'>>, serviceId?: string) => void;
}
const ActivatePromocodeButton: FC<ActivatePromocodeButtonProps> = ({
  getCommissions
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    isMobile
  } = useBreakpoint();
  const {
    values,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    validateForm
  } = useFormikContext<PaymentFormValues>();
  const {
    isPromocodeActivated,
    setIsPromocodeActivated,
    setLastActivatedPromocode
  } = useCyberStore();
  const handlePromocodeResetClick = (e?: MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();
    setIsPromocodeActivated(false);
    setLastActivatedPromocode('');
    setFieldValue('promocode', '');
  };
  const handlePromocodeSubmitClick = async (e?: MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();
    const formErrors = await validateForm();
    const hasErrors = Object.keys(formErrors || {}).length > 0;
    if (hasErrors) {
      Object.keys(formErrors).forEach(key => {
        setFieldTouched(key, true);
        setFieldError(key, formErrors[key] as string);
      });
      const firstErrorFieldName = Object.keys(formErrors)[0];
      const selector = `[name=${firstErrorFieldName}]`;
      const errorElement = document.querySelector(selector) as HTMLElement;
      if (isMobile) {
        const errorElementRect = errorElement.getBoundingClientRect();
        window.scrollBy({
          top: errorElementRect.top - 100,
          behavior: 'smooth'
        });
      }
      errorElement.focus({
        preventScroll: true
      });
      return;
    }
    const {
      promocode
    } = values;
    if (!promocode) {
      setFieldError('promocode', 'Пустой промокод');
      return;
    }
    if (PROMOCODES_FROM_2K.includes(promocode.toUpperCase()) && Number(values.price) < 2000) {
      setFieldError('promocode', 'Промокод действует только при пополнении от 2.000 ₽');
      setIsPromocodeActivated(false);
      setLastActivatedPromocode('');
      return;
    }
    if (PROMOCODES.includes(promocode.toUpperCase()) || PROMOCODES_FROM_2K.includes(promocode.toUpperCase())) {
      setIsLoading(true);
      // fetch(
      //   'https://script.google.com/macros/s/AKfycbw49v_kB9B44lyN1dfADUox7kttN8gWQq1NEtPm24kvcL5kjs96kFFcZdn0jwhM3Zkx/exec',
      //   {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'text/plain;charset=utf-8',
      //     },
      //     body: JSON.stringify({
      //       promoCode: promocode.toUpperCase(),
      //       login: values.login,
      //       time: new Date().toISOString(),
      //     }),
      //     redirect: 'follow',
      //   }
      // )
      // .then((response) => response.json())
      new Promise(res => {
        setTimeout(() => {
          res({
            status: 'success',
            message: 'Промокод применен'
          });
        }, 1000);
      }).then((data: {
        status: string;
        message: string;
      }) => {
        if (data.status === 'success') {
          setIsPromocodeActivated(true);
          setLastActivatedPromocode(promocode.toUpperCase());
          getCommissions(getSteamAccountFinalAmount(Number(values.price)), '24916');
        } else {
          setFieldError('promocode', data.message);
        }
      }).catch(() => {
        setIsPromocodeActivated(false);
        setLastActivatedPromocode('');
        setFieldError('promocode', MESSAGE_ERROR_PROMOCODE);
      }).finally(() => {
        setIsLoading(false);
      });
    } else {
      setIsPromocodeActivated(false);
      setLastActivatedPromocode('');
      getCommissions(getSteamAccountFinalAmount(Number(values.price)), '24916');
      setFieldError('promocode', 'Промокод не существует');
    }
  };
  return <ActivatePromocodeButtonWrapper>
      <Button isLoading={isLoading} disabled={!isPromocodeActivated && !values.promocode} size="44" family="MTSCompact" transform="none" onClick={isPromocodeActivated ? handlePromocodeResetClick : handlePromocodeSubmitClick}>
        {isPromocodeActivated ? 'Сбросить' : 'Применить'}
      </Button>
    </ActivatePromocodeButtonWrapper>;
};
export default ActivatePromocodeButton;
const ActivatePromocodeButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ActivatePromocodeButtonWrapper",
  class: "a1o4l7be",
  propsAsIs: false
});

require("./ActivatePromocodeButton.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ActivatePromocodeButton.tsx");